import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import { selectAuth } from "../reducers/authSlice";
import Login from "../pages/login/Login";
import Inicio from "../pages/inicio/Inicio";
import Error from "../pages/error/Error";
import Perfil from "../pages/perfil/Perfil";
import Ejemplo from "../pages/ejemplo/Ejemplo";
import Firmado from "../pages/firmado/Firmado";

import BandejaEntrada from "../pages/bandejaEntrada/BandejaEntrada";
import VerTramite from "../pages/verTramite/VerTramite";
import AltaTramite from "../pages/altaTramite/AltaTramite";
import EditarTramite from "../pages/editarTramite/EditarTramite";

import MovimientoExpediente from "../pages/movimientoExpediente/MovimientoExpediente"

import ConsultaMulticriterios from "../pages/consultaMulticriterios/ConsultaMulticriterios";
import ConsultaGerencial from "../pages/Consultas Gerencial/ConsultaGerencial";
import SeguirTramites from "../pages/seguir/SeguirTramites";
import ConsultaArchivados from "../pages/consultaArchivados/ConsultaArchivados";
import Terminos from "../pages/terminos/Terminos";
import Ayuda from "../pages/ayuda/Ayuda";
import ConsultaSeguir from "../pages/consultaSeguir/ConsultaSeguir";
import ConsultaGruposPage from "../pages/consultaGrupos/ConsultaGruposPage";
import GestionarGrupoPage from "../pages/gestionarGrupo/GestionarGrupoPage";

const PrivateRoute = ({ children, ...rest }) => {
  const auth = useSelector(selectAuth);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

const Body = () => {
  return (
    <>
      <Switch>
        {/* RUTAS PÚBLICAS */}
        <Route exact path="/login" component={Login} />

        <Route exact path="/publica">
          <p>Esta es una ruta pública</p>
        </Route>

        {/* RUTAS PRIVADAS */}
        <PrivateRoute exact path="/">
          <Inicio />
        </PrivateRoute>

        <PrivateRoute exact path="/perfil">
          <Perfil />
        </PrivateRoute>

        <PrivateRoute exact path="/bandeja_entrada">
          <BandejaEntrada funcion="/bandeja_entrada" />
        </PrivateRoute>

        <PrivateRoute exact path="/registrar_recepcion">
          <Ejemplo funcion="/registrar_recepcion" />
        </PrivateRoute>

        <PrivateRoute path="/ver_tramite/:tramiteId">
          <VerTramite funcion="/ver_tramite" />
        </PrivateRoute>

        <PrivateRoute exact path="/alta_tramite">
          <AltaTramite funcion="/alta_tramite" />
        </PrivateRoute>

        <PrivateRoute exact path="/consultaMulticriterios">
          <ConsultaMulticriterios funcion="/consultaMulticriterios" />
        </PrivateRoute>

        <PrivateRoute exact path="/seguir_tramites">
          <SeguirTramites funcion="/seguir_tramites" />
        </PrivateRoute>
        <PrivateRoute exact path="/consulta_gerencial">
          <ConsultaGerencial funcion="/consulta_gerencial" />
        </PrivateRoute>
        
        <PrivateRoute exact path="/movimientos_masivos">
          <MovimientoExpediente funcion="/movimientos_masivos" />
        </PrivateRoute>

        <PrivateRoute exact path="/archivados">
          <ConsultaArchivados funcion="/archivados" />
        </PrivateRoute>

        <PrivateRoute exact path="/terminos">
          <Terminos/>
        </PrivateRoute>

        <PrivateRoute exact path="/ayuda">
          <Ayuda/>
        </PrivateRoute>

        <Route exact path="/firmado">
          <Firmado />
        </Route>

        <PrivateRoute path="/editar_tram">
          <EditarTramite funcion="/editar_tramite" />
        </PrivateRoute>

        <PrivateRoute path="/editar_tramite/:tramiteId">
          <EditarTramite funcion="/editar_tramite" />
        </PrivateRoute>

        <PrivateRoute path="/consulta/expediente/seguir">
          <ConsultaSeguir/>
        </PrivateRoute>

        <PrivateRoute path="/grupos">
          <ConsultaGruposPage funcion="/grupos" />
        </PrivateRoute>

        <PrivateRoute path="/grupo/:grupoId">
          <GestionarGrupoPage funcion="/grupo" />
        </PrivateRoute>

        {/* RUTA DE ERROR */}
        <Route>
          <Error msg="Página no encontrada" />
        </Route>
      </Switch>
    </>
  );
};

export default Body;
